import {
  faInstagram,
  faTiktok,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import logo from '../assets/Logo_1.png';
import { Link } from 'react-router-dom';
import { HashLink as ScrollLink } from 'react-router-hash-link';

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-top">
        <div className="footer-grid-one">
          <div className="footer-grid-one-top">
            <div className="footer-logo-container">
              <img src={logo} alt="fitness space log" className="logo" />
            </div>
            <div className="footer-grid-one-text">
              Fitness Space has empowered individuals to achieve sustainable
              weight loss and fitness goals by promoting straight forward
              lifestyle adjustments that encourage healthier choices. Our
              approach has guided over 10,000 users to attain not just healthy
              weight loss but also wellness goals, fostering sustainable
              well-being.
            </div>
          </div>

          <div className="footer-grid-one-bottom">
            <div>Contact us</div>
            <div>Info.fitspaceng.com</div>
          </div>
        </div>
        <div className="footer-grid-two">
          <div className="footer-grid-two-header">Locations:</div>
          <div className="footer-grid-two-address-container">
            <div className="footer-grid-two-address-header">Lagos Office:</div>
            <div className="footer-grid-two-address">
              No 18 Dolo Oyekun, Lekki, Lagos State.
            </div>
          </div>
          <div className="footer-grid-two-address-container">
            <div className="footer-grid-two-address-header">Enugu Office:</div>
            <div className="footer-grid-two-address">
              No 46 Kenneth Street, Beside Vance Hotel, Enugu, Enugu State
            </div>
          </div>
        </div>
        <div className="last-footer-grids">
          <div className="last-footer-grids-header">Services</div>
          <div className="last-footer-grids-text-container">
            <div className="last-footer-grids-text">Nutrient dense meals</div>
            <div className="last-footer-grids-text">Portion Control guide</div>
            <div className="last-footer-grids-text">
              Home Workout
            </div>
            <div className="last-footer-grids-text">Intermittent Fasting</div>
          </div>
        </div>
        <div
          className="last-footer-grids"
          style={{
            cursor: 'pointer',
          }}
        >
          <div className="last-footer-grids-header">Why Fitness Space</div>
          <div className="last-footer-grids-text-container">
            <ScrollLink to={'#testimonial'} className="last-footer-grids-text">
              Stories
            </ScrollLink>
            <div className="last-footer-grids-text">Learn</div>
            <div className="last-footer-grids-text">FAQS</div>
          </div>
        </div>
        <div
          className="last-footer-grids"
          style={{
            cursor: 'pointer',
          }}
        >
          <div className="last-footer-grids-header">Legal</div>
          <div className="last-footer-grids-text-container">
            <div className="last-footer-grids-text">Terms</div>
            <div className="last-footer-grids-text">Privacy</div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="copyright">
          &copy; {new Date().getFullYear()} Fitness space. All Rights Reserved.
        </div>
        <div className="social-icons">
          <Link
            to={'https://www.instagram.com/getfitness.space'}
            target="_blank"
            className="social-icons-link"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </Link>
          <Link
            to={'https://www.twitter.com/FitnessSpace_Ng'}
            target="_blank"
            className="social-icons-link"
          >
            <FontAwesomeIcon icon={faTwitter} />
          </Link>
          <Link
            to={'https://www.youtube.com/@fitnessspace1410'}
            target="_blank"
            className="social-icons-link"
          >
            <FontAwesomeIcon icon={faYoutube} />
          </Link>
          <Link
            to={'https://www.tiktok.com/@getfitness.space'}
            target="_blank"
            className="social-icons-link"
          >
            <FontAwesomeIcon icon={faTiktok} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
